class LoadMoreProducts extends HTMLElement {
  constructor() {
    super();

    this.button = this.querySelector('[data-load-more-button]');
    this.count = this.querySelector('[data-load-more-count]');
    this.track = this.querySelector('[data-load-more-track]');
    this.fill = this.querySelector('[data-load-more-fill]');
    this.end = this.querySelector('[data-load-more-end]');
    this.loading = false;

    if (this.button) this.button.addEventListener('click', this.loadMore.bind(this));
  }

  async loadMore() {
    const url = this.dataset.nextUrl;
    const grid = document.getElementById('product-grid');
    if (!url || !grid || this.loading) return;

    this.loading = true;
    this.setAttribute('aria-busy', 'true');
    if (this.button) this.button.disabled = true;

    try {
      const response = await fetch(url);
      if (!response.ok) throw new Error(`Request failed: ${response.status}`);

      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const nextGrid = doc.getElementById('product-grid');
      if (nextGrid) nextGrid.querySelectorAll(':scope > li').forEach((item) => grid.appendChild(item));

      this.sync(doc);
    } catch (error) {
      console.error('Load more failed:', error);
    } finally {
      this.loading = false;
      this.removeAttribute('aria-busy');
      if (this.button) this.button.disabled = false;
    }
  }

  // The fetched page carries its own copy of this control, already holding the
  // cumulative count and bar width for everything loaded so far. Copying those
  // over keeps the pluralised, translated string coming from Liquid instead of
  // being reassembled here. Updating in place (rather than replacing innerHTML)
  // keeps the button binding and the aria-live region intact.
  sync(doc) {
    const next = doc.querySelector('load-more-products');
    if (!next) return;

    const nextCount = next.querySelector('[data-load-more-count]');
    if (nextCount && this.count) this.count.innerHTML = nextCount.innerHTML;

    const nextFill = next.querySelector('[data-load-more-fill]');
    if (nextFill && this.fill) this.fill.style.width = nextFill.style.width;

    const nextTrack = next.querySelector('[data-load-more-track]');
    if (nextTrack && this.track) {
      this.track.setAttribute('aria-valuenow', nextTrack.getAttribute('aria-valuenow'));
    }

    if (next.dataset.nextUrl) {
      this.dataset.nextUrl = next.dataset.nextUrl;
      return;
    }

    // Last page: retire the button and reveal the end-of-list note, catching
    // focus if it was sitting on the button that just disappeared.
    delete this.dataset.nextUrl;
    const buttonHadFocus = this.button && document.activeElement === this.button;
    if (this.button) this.button.hidden = true;
    if (!this.end) return;

    this.end.hidden = false;
    if (buttonHadFocus) this.end.focus();
  }
}

customElements.define('load-more-products', LoadMoreProducts);
